module.exports = __webpack_public_path__ + "static/img/facebook.8f8f74ed.svg";